export const productsEndPoints = {
  getListByIds: (queryString: string) => `/products/listByIds${queryString}`,
};
